var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"payment-card py-2 px-2 px-sm-4 rounded-lg d-block",class:{ 'success': _vm.success },attrs:{"outlined":""}},[(_vm.$vuetify.breakpoint.smAndUp)?_c('v-icon',[_vm._v("mdi-account")]):_vm._e(),_c('div',{staticClass:"body-1 text-sm-h6"},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }